const fallbackHeaderData = {
  type: "Header",
  mainNavItems: []
};
function selectHeaderVariant(data) {
  const total = data.variants.reduce((acc, { allocation }) => {
    return acc + allocation;
  }, 0);
  if (total !== 1) {
    return { data: data.variants[0].header };
  }
  const localStorageKey = `zapier.header.experiment.${data.id}`;
  const storedVariant = localStorage.getItem(localStorageKey);
  if (storedVariant) {
    const variant = data.variants.find(({ id }) => {
      return id === storedVariant;
    });
    if (variant) {
      return {
        name: variant.name,
        data: variant.header,
        experiment: data.name
      };
    }
  }
  const x = Math.random();
  let min = 0;
  for (const variant of data.variants) {
    const max = min + variant.allocation;
    if (x > min && x < max) {
      localStorage.setItem(localStorageKey, variant.id);
      return {
        name: variant.name,
        data: variant.header,
        experiment: data.name
      };
    }
    min += variant.allocation;
  }
  return { data: data.variants[0].header };
}
export {
  fallbackHeaderData,
  selectHeaderVariant
};
